export function clamp(val: number, minVal: number, maxVal: number): number {
	return Math.min(Math.max(val, minVal), maxVal)
}
